@if (label()) {
  <app-label [required]="isRequired()" [value]="label()" />
}

<div
  class="focusable-div flex gap-1 items-center shadow-sm rounded-lg overflow-hidden transition-all focus-within:enabled:shadow-[0_0_0px_3px_var(--highlight)] border-[1.5px] border-[var(--light)] hover:enabled:border-[var(--muted)] text-black"
>
  <input
    type="text"
    placeholder="+_"
    [size]="2"
    class="outline-none border-none py-2 pl-4"
    (input)="countryCodeChanged($event)"
    [value]="countryCallingCode() ?? ''"
  />
  <div class="w-px bg-light self-stretch"></div>
  <input
    type="tel"
    [disabled]="disabled()"
    [value]="nationalFormatted() ?? ''"
    (input)="onNationalInput($any($event.target).value)"
    [placeholder]="exampleNumber()"
    class="flex-1 outline-none border-none py-2 px-4 {{ inputStyleClass() }}'"
    [autocomplete]="'tel'"
    [inputMode]="'tel'"
  />
</div>

@if (errorMessage()) {
  <app-validation-output [value]="errorMessage()" [type]="'error'" />
}
